<template>
  <div class="chart">
    <div class="amountCollect">
      <div class="amountCollectCo">
        <div class="amountHead itemHead">
          <div class="leftInfo">
            <i></i><span>收款金额</span>
            <el-tooltip content="收款成功的金额总和" placement="top">
              <i class="tips"></i>
            </el-tooltip>
            <span>{{ customData.timeNow }}</span>
          </div>
        </div>
        <div class="moneyShow">
          <div class="leftData">
            <p class="date">{{ customData.timeNow }} 查询结果</p>
            <p class="title">收款总额(元)</p>
            <p class="money">{{ isCompare.totalAmount }}</p>
            <div class="trend" v-if="isCompare.needCompare">
              <p v-if="isCompare.differenceAmount > 0 || isCompare.differenceAmount == 0">
                <i class="rise"></i> <span>比前一天上涨{{ isCompare.differenceAmount }}元</span>
              </p>
              <p v-else>
                <i class="decriase"></i> <span style="color:#F47574;">比前一天减少{{ Math.abs(isCompare.differenceAmount) }}元</span>
              </p>
            </div>
          </div>
          <div id="lineChart" style="height:360px;width:85%;"></div>
        </div>
      </div>
    </div>
    <div class="strokeNumber">
      <div class="strokeNumCon">
        <div class="leftStroke sameStoke">
          <div class="itemHead sameItem">
            <div class="leftInfo">
              <div class="title">
                <i></i><span>收款笔数</span>
                <el-tooltip content="收款成功的笔数总和" placement="top">
                  <i class="tips"></i>
                </el-tooltip>
                <span>{{ customData.timeNow }}</span>
              </div>
              <div class="money">
                <p class="moneyNum">
                  <span>{{ isCompare.tradeNum }}</span> <span>笔</span>
                </p>
                <div class="moneytrend" v-if="isCompare.needCompare">
                  <p v-if="isCompare.differenceTradeNum > 0 || isCompare.differenceTradeNum == 0">
                    <i class="rise"></i> <span style="color:#58ba2d">比前一天上涨{{ isCompare.differenceTradeNum }}笔</span>
                  </p>
                  <p v-else>
                    <i class="decriase"></i> <span>比前一天减少{{ Math.abs(isCompare.differenceTradeNum) }}笔</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="chartOfBox">
            <div id="collectMount" style="width: 100%;height:500px;"></div>
          </div>
        </div>
        <div class="rightStroke sameStoke">
          <div class="itemHead sameItem">
            <div class="leftInfo">
              <div class="title">
                <i></i><span>交易笔数</span>
                <el-tooltip content="收款成功笔数+退款成功笔数" placement="top">
                  <i class="tips"></i>
                </el-tooltip>
                <span>{{ customData.timeNow }}</span>
              </div>
              <div class="money">
                <p class="moneyNum">{{ isCompare.transactionNum }} <span>笔</span></p>
                <div class="moneytrend" v-if="isCompare.needCompare">
                  <p v-if="isCompare.differenceTransactionNum > 0 || isCompare.differenceTransactionNum == 0">
                    <i class="rise"></i> <span style="color:#58ba2d">比前一天上涨{{ isCompare.differenceTransactionNum }}笔</span>
                  </p>
                  <p v-else>
                    <i class="decriase"></i> <span>比前一天减少{{ Math.abs(isCompare.differenceTransactionNum) }}笔</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="chartOfBox">
            <div id="tradeMount" style="width:100%;height:500px;"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="storeCom" v-show="isShowStorePart">
      <div class="stroreComCon">
        <div class="storeHead itemHead">
          <div class="leftInfo">
            <i></i><span>门店对比</span>
            <el-tooltip content="各门店的收款笔数、收款金额" placement="top">
              <i class="tips"></i>
            </el-tooltip>
            <div class="typeOfChart">
              <div class="itemType">
                <span class="rectangle money"></span>
                <span class="text">收款金额</span>
              </div>
              <div class="itemType">
                <span class="rectangle number"></span>
                <span class="text">收款笔数</span>
              </div>
            </div>
          </div>
          <div class="rightdate">
            <p class="timeNow">您选择的日期范围为：{{ customData.timeNow }}</p>
          </div>
        </div>
        <div class="storeBody" ref="storeCharts">
          <!-- <div class="nodataBox" v-show="isShowStore">
            <p class="nodate">暂无数据</p>
          </div> -->
          <div class="noDataImg" v-show="isShowStore"><i class="el-icon-document"></i></div>
          <div id="storeCom" style="width: 100%;height:463px;margin:0 auto;"></div>
        </div>
      </div>
    </div>
    <div class="strokeNumber customAndactive" v-show="isShowCustomChart">
      <div class="strokeNumCon">
        <div class="leftStroke sameStoke">
          <div class="itemHead sameItem">
            <div class="leftInfo">
              <div class="title">
                <i></i><span>顾客人数</span>
                <el-tooltip placement="top">
                  <div slot="content">
                    消费者使用不同付款方式进行付款，<br />每种付款方式算为1名顾客。总店查<br />看所有门店的顾客人数，会对同一<br />名消费者在不同分店消费进行去重,<br />当天数据不做计算
                  </div>
                  <i class="tips"></i>
                </el-tooltip>
              </div>
            </div>
            <div class="rightdate">
              <p class="timeNow">您选择的日期范围为：{{ customData.timeNow }}</p>
            </div>
          </div>
          <div class="chartOfBox">
            <div class="noDataImg" v-show="!customData.isHasCustomData"><i class="el-icon-document"></i></div>
            <div id="custom" style="width:100%;height:500px;"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 营业收入 -->
    <div class="amountCollect buss-income">
      <div class="amountCollectCo">
        <div class="amountHead itemHead">
          <div class="leftInfo">
            <i></i><span>营业收入</span>
            <el-tooltip content="实际的收入金额，既收款成功金额-退款成功金额" placement="top">
              <i class="tips"></i>
            </el-tooltip>
            <span>{{ customData.timeNow }}</span>
          </div>
        </div>
        <div class="moneyShow">
          <div class="leftData">
            <p class="date">{{ customData.timeNow }} 查询结果</p>
            <p class="title">营业收入(元)</p>
            <p class="money">{{ isCompare.revenueAmount }}</p>
            <div class="trend" v-if="isCompare.needCompare">
              <p v-if="isCompare.differenceTransactionNum > 0 || isCompare.differenceTransactionNum == 0">
                <i class="rise"></i> <span>比前一天上涨{{ isCompare.differenceTransactionNum }}元</span>
              </p>
              <p v-else>
                <i class="decriase"></i> <span style="color:#F47574;">比前一天减少{{ Math.abs(isCompare.differenceTransactionNum) }}元</span>
              </p>
            </div>
          </div>
          <div id="bussIncomeLine" style="height:360px;width:85%;"></div>
        </div>
      </div>
    </div>
    <div class="collectPay">
      <div class="collectPayCon">
        <div class="collectPayHead itemHead">
          <div class="leftInfo">
            <i></i><span>收款方式</span>
            <span>{{ customData.timeNow }}</span>
          </div>
        </div>
        <div class="collectPayBody">
          <div class="left" v-show="isShowPieChart">
            <div class="noDataImg"><i class="el-icon-document"></i></div>
            <p class="nodate">暂无数据</p>
          </div>
          <div class="left" v-show="!isShowPieChart" ref="payPieChart">
            <div id="payWayAmount" style="width: 100%;height:281px;margin:0 auto"></div>
            <div class="title">营业收入</div>
          </div>
          <div class="right" v-show="isShowPieChart">
            <div class="noDataImg"><i class="el-icon-document"></i></div>
            <p class="nodate">暂无数据</p>
          </div>
          <div class="right" v-show="!isShowPieChart" ref="collNumPieChart">
            <div id="collectNumber" style="width: 100%;height:281px;margin:0 auto"></div>
            <div class="title">交易笔数</div>
          </div>
          <div class="bottomBar">
            <div class="zfb same"><i></i><span>支付宝</span></div>
            <div class="wx same"><i></i><span>微信</span></div>
            <div class="ysf same"><i></i><span>云闪付</span></div>
            <div class="yl same"><i></i><span>银联</span></div>
            <div class="szr same"><i></i><span>数字人民币</span></div>

          </div>
        </div>
      </div>
    </div>
    <!-- 收银点对比 -->
    <div class="cashierCompare" v-show="showCashierChart">
      <div class="cashierCollectCo">
        <div class="cashierHead itemHead">
          <div class="leftInfo">
            <i class="leftIcon"></i><span>收银点营业数据对比</span>
            <el-tooltip content="各个收银点数据对比" placement="top">
              <i class="tips"></i>
            </el-tooltip>
            <span>{{ customData.timeNow }}</span>
            <el-select class="sortType" v-model="rankType" size="mini" @change="changeSort(rankType)">
              <el-option v-for="(item, type) in rankTypes" :key="type" :label="item.label" :value="item.type"> </el-option>
            </el-select>
          </div>
        </div>
        <div class="dataShow">
          <div class="leftData">
            <p class="date">{{ customData.timeNow }} 查询结果</p>
            <div class="resDiv" v-if="rankType === 1 || rankType === 2">
              <p v-for="(item, ind) in cashierIncomeList" :key="ind">
                {{ item[0] }}营业收入<span>{{ item[1] / 100 }}</span
                >元
              </p>
            </div>
            <div class="resDiv" v-if="rankType === 3 || rankType === 4">
              <p v-for="(item, ind) in cashierTransList" :key="ind">
                {{ item[0] }}收款笔数<span>{{ item[1] }}</span
                >笔
              </p>
            </div>
          </div>
          <div id="cashierChart" style="height:360px;width:1200px;">
            <div class="noDataImg"><i class="el-icon-document"></i></div>
            <p class="nodate">暂无数据</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import macarons from "../theme/macarons";
import collectMoneyLineOptios from "../libs/collectMoneyLineOptios";
import storeComBarOptions from "../libs/storeComBarOptions";
import tradeMountLineOptions from "../libs/tradeMountLineOptions";
import collectMountLineOptions from "../libs/collectMountLineOptions";
import customBarOptions from "../libs/customBarOptions";
import activeBarOptions from "../libs/activeBarOptions";
import bussIncomeLineOptios from "../libs/bussIncomeLineOptios";
import payWayAmountPieOptions from "../libs/payWayAmountPieOptions";
import collectNumberPieOptions from "../libs/collectNumberPieOptions";
import cashierBarOptions from "../libs/cashierBarOptions";
import { payColor } from "@/global-config";
import { formatDate } from "@/utils/index";
// import search from "./components/search";

const echarts = require("echarts");

export default {
  components: {
    // search,
  },
  props: {
    cashierData: {
      type: Object,
    },
    tipsDateTimeRange: {
      type: String,
      default: "",
    },
    collectPieAccountData: {
      type: Array,
    },
    collectPieNumberData: {
      type: Array,
    },
    custom: {
      type: Object,
    },
    transactionNum: {
      type: Object,
    },
    tradeNum: {
      type: Object,
    },
    totalAmount: {
      type: Object,
    },
    merchantChartArr: {
      type: Object,
    },
    revenueAmountList: {
      type: Object,
    },
    compare: {
      type: Object,
    },
  },
  data() {
    return {
      showCashierChart: false,
      cashierVal: [],
      cashierIncomeList: [],
      cashierTransList: [],
      rankType: 1,
      rankTypes: [{ label: "营业收入从高到低", type: 1 }, { label: "营业收入从低到高", type: 2 }, { label: "收款笔数从高到低", type: 3 }, { label: "收款笔数从低到高", type: 4 }],
      collectMoneyLineOptios: collectMoneyLineOptios(),
      storeComBarOptions: storeComBarOptions(),
      tradeMountLineOptions: tradeMountLineOptions(),
      collectMountLineOptions: collectMountLineOptions(),
      customBarOptions: customBarOptions(),
      activeBarOptions: activeBarOptions(),
      bussIncomeLineOptios: bussIncomeLineOptios(),
      payWayAmountPieOptions: payWayAmountPieOptions(),
      collectNumberPieOptions: collectNumberPieOptions(),
      cashierBarOptions: cashierBarOptions(),
      customData: {
        needCompare: false,
        differenceCustomerNum: "",
        totalCustomerNum: "",
        isHasCustomData: false,
        timeNow: "",
      },
      isCompare: {
        needCompare: false,
        totalAmount: 0,
        tradeNum: 0,
        transactionNum: 0,
        differenceAmount: 0,
        differenceTradeNum: 0,
        differenceTransactionNum: 0,
      },
      isShowPieChart: false,
      isShowStore: false,
      isShowStorePart: true,
      isShowCustomChart: true,
    };
  },
  watch: {
    // 菜单展开收起，图标自适应
    getshowsidebar() {
      let timer;
      const that = this;
      that.drawPayWayAmountChart();
      that.drawCollectNumberChart();
      that.drawStoreComChart();

      clearTimeout(timer);
      timer = setTimeout(() => {
        that.collectMoneyChart.resize();
        that.collectMountChart.resize();
        that.tradeMountChart.resize();
        that.storeComChart.resize();
        that.customBarChart.resize();
        that.bussIncomeLineChart.resize();
        that.payWayAmountChart.resize();
        that.collectNumberChart.resize();
        if (that.showCashierChart === true && that.cashierBarChart) {
          that.cashierBarChart.resize();
        }
      }, 250);
    },
    // 前面三个图的比较
    compare: {
      handler(val) {
        if (val) {
          this.isCompare = val;
        }
      },
    },
    // 收款金额
    totalAmount: {
      handler(val) {
        const that = this;
        if (val) {
          const changeMoneyUnit = val.num.map(e => e / 100);
          that.collectMoneyLineOptios.xAxis[0].data = val.time;
          that.collectMoneyLineOptios.series[0].data = changeMoneyUnit;
          that.drawCollectMoneyChart();
        }
      },
    },
    // 收款笔数
    tradeNum: {
      handler(val) {
        const that = this;
        if (val) {
          that.collectMountLineOptions.xAxis[0].data = val.time;
          that.collectMountLineOptions.series[0].data = val.num;
          that.drawCollectMountChart();
        }
      },
    },
    // 交易笔数
    transactionNum: {
      handler(val) {
        const that = this;
        if (val) {
          that.tradeMountLineOptions.xAxis[0].data = val.time;
          that.tradeMountLineOptions.series[0].data = val.num;
          that.drawtradeMountChart();
        }
      },
    },
    // 门店对比柱状图
    merchantChartArr: {
      handler(val) {
        const that = this;
        if (val) {
          that.isShowStorePart = val.merchantIdList.length > 1 || val.merchantIdList[0] === "@";
          that.storeComBarOptions.title.show = val.name.length === 0;
          that.storeComBarOptions.dataZoom.type = val.name.length === 0 ? "inside" : "slider";
          that.storeComBarOptions.xAxis[0].show = val.name.length !== 0;
          that.isShowStore = val.name.length === 0;
          const changeMoneyUnit = val.amount.map(e => e / 100);
          that.storeComBarOptions.xAxis[0].data = val.name;
          that.storeComBarOptions.series[0].data = changeMoneyUnit;
          that.storeComBarOptions.series[1].data = val.num;
          that.drawStoreComChart();
        }
        setTimeout(() => {
          that.storeComChart.resize();
        }, 100);
      },
    },
    // 顾客人数柱状图
    custom: {
      handler(val) {
        const that = this;
        if (val) {
          // 是否有数据
          that.customData.isHasCustomData = val.time.length > 0;
          // 没有数据时
          that.customBarOptions.title.show = val.time.length === 0;
          that.customBarOptions.xAxis[0].show = val.time.length !== 0;
          that.customBarOptions.dataZoom.type = val.time.length === 0 ? "inside" : "slider";
          that.customBarOptions.xAxis[0].data = val.time;
          that.customBarOptions.series[0].data = val.newData;
          that.customBarOptions.series[1].data = val.data;
          that.customData.needCompare = val.needCompare;
          that.customData.differenceCustomerNum = val.differenceCustomerNum;
          that.customData.totalCustomerNum = val.totalCustomerNum;
          // 选择的日期
          that.customData.timeNow = val.timeNow;
          const timeArr = that.customData.timeNow.split("~");
          const nowDate = new Date().getTime();
          // 获取今天的日期,如果开始时间和结束时间都是今天，那就隐藏顾客人数的图表
          /* eslint-disable-next-line */
          timeArr[0] = timeArr[0].replace(/^\s*|\s*$/g, "");
          timeArr[1] = timeArr[1].replace(/^\s*|\s*$/g, "");
          if (timeArr[0] === formatDate(nowDate) && timeArr[1] === formatDate(nowDate)) {
            this.isShowCustomChart = false;
          } else {
            this.isShowCustomChart = true;
          }
        }
        that.drawCustomBarChart();
        setTimeout(() => {
          that.customBarChart.resize();
        }, 100);
      },
    },
    // 营业收入
    revenueAmountList: {
      handler(val) {
        const that = this;
        if (val) {
          const changeMoneyUnit = val.num.map(e => e / 100);
          that.bussIncomeLineOptios.xAxis[0].data = val.time;
          that.bussIncomeLineOptios.series[0].data = changeMoneyUnit;
          that.drawBussIncomeChart();
        }
      },
    },

    // 饼状图收款金额
    collectPieAccountData: {
      handler(val) {
        const that = this;
        if (val) {
          that.payWayAmountPieOptions.series[0].data = val;
          // 颜色
          that.payWayAmountPieOptions.color = [];
          that.payWayAmountPieOptions.series[0].data.forEach((v) => {
            that.payWayAmountPieOptions.color.push(payColor[v.name]);
          });
          that.allData = 0;
          val.forEach((element) => {
            that.allData += element.value;
          });
          that.isShowPieChart = that.allData === 0;
          that.drawPayWayAmountChart();
        }
      },
    },
    // 饼状图收款笔数
    collectPieNumberData: {
      handler(val) {
        const that = this;
        if (val) {
          that.collectNumberPieOptions.series[0].data = val;

          // 颜色
          that.collectNumberPieOptions.color = [];
          that.collectNumberPieOptions.series[0].data.forEach((v) => {
            that.collectNumberPieOptions.color.push(payColor[v.name]);
          });
          that.drawCollectNumberChart();
        }
      },
    },
    // 收银点对比
    cashierData: {
      handler(val) {
        const that = this;
        this.rankType = val.rankType;
        this.showCashierChart = val.showCashierChart;
        if (val) {
          that.cashierBarOptions.title.text = "";
          if (val.num) {
            val.num.sort((a, b) => b.revenueAmount - a.revenueAmount);
            that.cashierVal = val.num;
            that.cashierIncomeList = val.num.map(v => [v.cashierAreaName, v.revenueAmount]);
            that.cashierTransList = val.num.map(v => [v.cashierAreaName, v.tradeNum]);
            that.cashierBarOptions.xAxis.data = val.num.map(v => v.cashierAreaName);
            that.cashierBarOptions.series[0].data = val.num.map(v => v.revenueAmount);
            that.cashierBarOptions.series[1].data = val.num.map(v => v.tradeNum);
          } else {
            // 为空则初始化options
            that.cashierBarOptions = cashierBarOptions();
            that.cashierIncomeList = [];
            that.cashierTransList = [];
            that.cashierVal = [];
          }
          that.drawCashierBarChart();
        }
      },
    },
  },
  computed: {
    getshowsidebar() {
      return this.$store.state.app.sidebar.opened;
    },
  },
  methods: {
    // 更改收银点排序方式
    changeSort(rankType) {
      switch (rankType) {
        case 2:
          this.cashierVal.sort((a, b) => a.revenueAmount - b.revenueAmount);
          break;
        case 3:
          this.cashierVal.sort((a, b) => b.tradeNum - a.tradeNum);
          break;
        case 4:
          this.cashierVal.sort((a, b) => a.tradeNum - b.tradeNum);
          break;
        default:
          this.cashierVal.sort((a, b) => b.revenueAmount - a.revenueAmount);
      }
      this.cashierIncomeList = this.cashierVal.map(v => [v.cashierAreaName, v.revenueAmount]);
      this.cashierTransList = this.cashierVal.map(v => [v.cashierAreaName, v.tradeNum]);
      this.cashierBarOptions.xAxis.data = this.cashierVal.map(v => v.cashierAreaName);
      this.cashierBarOptions.series[0].data = this.cashierVal.map(v => v.revenueAmount);
      this.cashierBarOptions.series[1].data = this.cashierVal.map(v => v.tradeNum);
      this.drawCashierBarChart();
    },
    drawCollectMoneyChart() {
      this.collectMoneyChart = echarts.init(document.getElementById("lineChart"), "macarons");
      // 绘制收款金额折线图表
      this.collectMoneyChart.setOption(this.collectMoneyLineOptios);
    },
    drawCollectMountChart() {
      this.collectMountChart = echarts.init(document.getElementById("collectMount"), "macarons");
      // 绘制收款笔数折线图
      this.collectMountChart.setOption(this.collectMountLineOptions);
    },
    drawtradeMountChart() {
      this.tradeMountChart = echarts.init(document.getElementById("tradeMount"), "macarons");
      // 绘制交易笔数折线图
      this.tradeMountChart.setOption(this.tradeMountLineOptions);
    },
    drawStoreComChart() {
      // 绘制门店对比柱状图
      this.storeComChart = echarts.init(document.getElementById("storeCom"), "macarons");
      this.storeComChart.setOption(this.storeComBarOptions);
    },
    drawCustomBarChart() {
      this.customBarChart = echarts.init(document.getElementById("custom"), "macarons");
      // 绘制顾客人数柱状图
      this.customBarChart.clear();
      this.customBarChart.setOption(this.customBarOptions);
    },
    drawCashierBarChart() {
      if (this.cashierBarChart) {
        this.cashierBarChart.clear();
      }
      if (this.cashierData.showCashierChart === true && this.cashierIncomeList.length) {
        this.cashierBarChart = echarts.init(document.getElementById("cashierChart"), "macarons");
        // 绘制收银点对比柱状图
        this.cashierBarChart.setOption(this.cashierBarOptions);
      }
    },
    drawPayWayAmountChart() {
      const payPieChart = document.getElementById("payWayAmount");
      payPieChart.style.width = `${window.innerWidth / 2 - 180}px`;
      // 重新设置宽度解决隐藏后宽度默认100pxbug

      this.payWayAmountChart = echarts.init(payPieChart, "macarons");
      // 绘制收款方式的收款金额饼状图
      this.payWayAmountChart.clear();
      this.payWayAmountChart.setOption(this.payWayAmountPieOptions);
    },
    drawBussIncomeChart() {
      this.bussIncomeLineChart = echarts.init(document.getElementById("bussIncomeLine"), "macarons");
      // 绘制营业收入折线图表
      this.bussIncomeLineChart.setOption(this.bussIncomeLineOptios);
    },
    drawCollectNumberChart() {
      const collNumPieChart = document.getElementById("collectNumber");
      collNumPieChart.style.width = `${window.innerWidth / 2 - 180}px`;
      // setTimeout(() => {
      // collNumPieChart.style.width = `${this.$refs.collNumPieChart.offsetWidth}px`;
      this.collectNumberChart = echarts.init(collNumPieChart, "macarons");
      // 绘制收款方式的收款笔数饼状图
      this.collectNumberChart.clear();
      this.collectNumberChart.setOption(this.collectNumberPieOptions);
      // }, 240);
    },
    // echarts自适应
    selfAdaption() {
      const that = this;
      setTimeout(() => {
        window.onresize = () => {
          that.collectMoneyChart.resize();
          that.collectMountChart.resize();
          that.tradeMountChart.resize();
          that.storeComChart.resize();
          that.customBarChart.resize();
          that.bussIncomeLineChart.resize();
          if (that.showCashierChart === true && that.cashierBarChart) {
            that.cashierBarChart.resize();
          }
        };
      }, 100);
    },
  },
  mounted() {
    this.drawCollectMoneyChart();
    this.drawStoreComChart();
    this.drawtradeMountChart();
    this.drawCollectMountChart();
    this.drawCustomBarChart();
    // this.drawActiveBarChart();
    this.drawBussIncomeChart();
    this.drawPayWayAmountChart();
    this.drawCollectNumberChart();
    this.drawCashierBarChart();
    this.selfAdaption();
  },
};
</script>

<style lang="scss">
.chart {
  .itemHead {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .leftInfo {
      display: flex;
      align-items: center;
    }
    .title {
      display: flex;
      align-items: center;
    }
    i {
      width: 24px;
      height: 24px;
      display: inline-block;
    }
    .tips {
      background: url("../../../assets/images/report/questionh.png") no-repeat !important;
      background-size: 100%;
      width: 16px;
      height: 16px;
      display: inline-block;
      margin-left: 6px;
      vertical-align: middle;
      cursor: pointer;
      margin-top: 1.5px;
    }
    span {
      color: #333333;
      font-size: 18px;
      margin-left: 13px;
      display: inline-block;
    }
    .timeNow {
      display: inline-block;
      vertical-align: bottom !important;
      margin-left: 20px !important;
      color: #333;
    }
  }

  //收款金额
  .amountCollect {
    background: #f7f7f7;
    overflow: hidden;
    .amountHead {
      i {
        background: url("../../../assets/images/report/collectamount.png") no-repeat;
        background-size: 100%;
      }
      padding: 23px 50px;
      box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 1);
      span {
        margin-top: 2px;
      }
    }
    .amountCollectCo {
      background: #fff;
      margin-top: 20px;
    }
    .moneyShow {
      padding: 50px 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .leftData {
        text-align: center;
        font-size: 14px;
        color: #999;
        border: 1px solid #e5e5e5;
        width: 389px;
        height: 365px;
        margin-right: 25px;
        .date {
          text-align: left;
          margin: 20px 0 80px 20px;
        }
        .money {
          font-weight: bold;
          color: #666;
          font-size: 50px;
          margin-top: 18px;
        }
        .trend {
          margin-top: 40px;
          i {
            display: inline-block;
            width: 10px;
            height: 13px;
            vertical-align: middle;
          }
          .rise {
            background: url("../../../assets/images/report/topGreen.png");
            background-size: 100%;
          }
          .decriase {
            background: url("../../../assets/images/report/downRed.png");
            background-size: 100%;
          }
          span {
            color: #58ba2d;
            margin-left: 10px;
          }
        }
      }
    }
  }
  // 收银点营业收入对比
  .cashierCompare {
    background: #f7f7f7;
    overflow: hidden;
    .cashierHead {
      .leftIcon {
        background: url("../../../assets/images/report/Survey.png") no-repeat;
        background-size: 100%;
      }
      padding: 23px 50px;
      box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 1);
      span {
        margin-top: 2px;
      }
    }
    .cashierCollectCo {
      background: #fff;
      margin-top: 20px;
      .sortType {
        width: 150px;
        margin-left: 20px;
      }
    }
    .dataShow {
      padding: 50px 50px;
      display: flex;
      // justify-content: space-between;
      align-items: center;
      .leftData {
        font-size: 14px;
        color: #999;
        border: 1px solid #e5e5e5;
        width: 357px;
        flex-shrink: 0;
        flex-grow: 0;
        height: 365px;
        margin-right: 25px;
        .date {
          text-align: left;
          margin: 20px 0 20px 20px;
        }
        .resDiv {
          margin-left: 25px;
          line-height: 30px;
          height: 76%;
          overflow-y: auto;
          p {
            color: #222;
            span {
              color: rgb(255, 166, 0);
            }
          }
        }
      }
      #cashierChart {
        flex-shrink: 0;
        position: relative;
        .nodate {
          height: 350px;
          text-align: center;
          line-height: 400px;
          color: #888;
        }
        .noDataImg {
          width: 80px;
          height: 80px;
          position: absolute;
          margin: auto;
          z-index: 10;
          top: 0;
          bottom: 80px;
          left: 0;
          right: 0;
          i {
            font-size: 80px;
            color: #ddd;
          }
        }
      }
    }
  }
  // 营业收入
  .buss-income {
    .leftInfo {
      i {
        background: url("../../../assets/images/report/bussIncome.png") no-repeat;
      }
    }
  }
  // 收款笔数
  .strokeNumber {
    .strokeNumCon {
      background: #f7f7f7;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .sameItem {
      display: flex;
      align-items: center;
      padding: 25px 45px;
      box-shadow: 0px 1px 0px 0px rgba(242, 243, 243, 1);
      .money {
        margin-left: 23px;
        p {
          display: inline-block;
          vertical-align: middle;
          margin: 0;
          color: #666;
        }
        .moneyNum {
          font-size: 16px;
          span {
            margin-left: 0px;
            font-size: 16px;
          }
        }
        .moneytrend {
          margin-left: 21px;
          display: inline-block;
          .decriase {
            width: 10px;
            height: 13px;
            vertical-align: middle;
            background: url("../../../assets/images/report/downRed.png") no-repeat;
          }
          .rise {
            width: 10px;
            height: 13px;
            vertical-align: middle;
            background: url("../../../assets/images/report/topGreen.png") no-repeat;
          }
          span {
            color: #f47574;
            font-size: 14px;
            margin-left: 0;
          }
        }
      }
    }
    .sameStoke {
      background: #fff;
      margin-top: 20px;
      width: 100%;
    }
    .chartOfBox {
      position: relative;
      padding: 60px 45px;
      width: 100%;
      .noDataImg {
        width: 80px;
        height: 80px;
        position: absolute;
        margin: auto;
        z-index: 10;
        top: 0;
        bottom: 80px;
        left: 0;
        right: 0;
        i {
          font-size: 80px;
          color: #ddd;
        }
      }
    }
    .leftStroke {
      .title {
        i {
          background: url("../../../assets/images/report/collectStroke.png") no-repeat;
          background-size: 100%;
        }
        span {
          margin-top: 2px;
        }
      }
    }
    .rightStroke {
      .title {
        i {
          background: url("../../../assets/images/report/tradeStroke.png") no-repeat;
          background-size: 100%;
        }
        span {
          margin-top: 1px;
        }
      }
    }
  }

  //门店对比
  .storeCom {
    background: #f7f7f7;
    padding-top: 20px;
    .stroreComCon {
      position: relative;
      .storeHead {
        padding: 24px 50px;
        box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 1);
        background: #fff;
        i {
          background: url("../../../assets/images/report/storeCom.png") no-repeat;
          background-size: 100%;
        }
        .typeOfChart {
          display: flex;
          margin-left: 50px;
          .itemType {
            .rectangle {
              display: inline-block;
              width: 22px;
              height: 4px;
              vertical-align: middle;
            }
            .money {
              background: #ffae00;
            }
            .number {
              background: #0095ff;
            }
            .text {
              font-size: 14px;
              font-weight: 400;
              color: #333;
              margin-left: 4px;
            }
          }
        }
      }
      .storeBody {
        padding: 60px 45px;
        .nodataBox {
          height: 400px;
          text-align: center;
          line-height: 460px;
          color: #999;
        }
        .noDataImg {
          width: 80px;
          height: 80px;
          position: absolute;
          margin: auto;
          z-index: 10;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          i {
            font-size: 80px;
            color: #ddd;
          }
        }
        background: #fff;
        margin-top: 1px;
      }
    }
  }

  //顾客人数和活动
  .customAndactive {
    .leftStroke {
      .title {
        i {
          background: url("../../../assets/images/report/custom.png");
          background-size: 100%;
        }
      }
    }
    .timeNow {
      display: inline-block;
      vertical-align: bottom !important;
      margin-left: 20px !important;
      color: #333 !important;
    }
  }

  //收款方式
  .collectPay {
    background: #f7f7f7;
    padding-top: 20px;
    .collectPayCon {
      background: #fff;
      .collectPayHead {
        padding: 23px 50px;
        box-shadow: 0px 1px 0px 0px rgba(234, 234, 234, 1);
        i {
          background: url("../../../assets/images/report/collectPay.png");
          background-size: 100%;
        }
        span {
          margin-top: 3px;
        }
      }
      .collectPayBody {
        display: flex;
        padding: 60px 0%;
        flex-wrap: wrap;
        .title {
          font-size: 18px;
          margin-top: 30px;
        }
        .nodate {
          height: 281px;
          text-align: center;
          line-height: 350px;
          color: #888;
        }
        .noDataImg {
          width: 80px;
          height: 80px;
          position: absolute;
          margin: auto;
          z-index: 10;
          top: 0;
          bottom: 80px;
          left: 0;
          right: 0;
          i {
            font-size: 80px;
            color: #ddd;
          }
        }
        .left {
          position: relative;
          text-align: center;
          width: 50%;
          border-right: 1px solid #eaeaea;
          .title {
            color: #ff7800;
          }
        }
        .right {
          position: relative;
          text-align: center;
          width: 50%;
          .title {
            color: #0295ff;
          }
        }
        .bottomBar {
          display: flex;
          margin: 0 auto;
          margin-top: 82px;
          .same {
            i {
              width: 10px;
              height: 10px;
              border-radius: 50%;
              display: inline-block;
              vertical-align: middle;
              margin-left: 50px;
            }
            span {
              color: #333;
              font-size: 14px;
              margin-left: 5px;
            }
          }
          .zfb {
            i {
              background: #0084ff;
            }
          }
          .wx {
            i {
              background: #17ce87;
            }
          }
          .yl {
            i {
              background: #ff9c00;
            }
          }
          .ysf {
            i {
              background: #f36361;
            }
          }
          .szr {
            i {
              background: #b3b3b3
            }
          }
        }
      }
    }
  }
}
</style>
